import React from 'react';

export const TRIAL_LIMITS = {
  ssp_pdf_export: false,
  poam_pdf_export: false,
  spreadsheet_export: false,
  policy_download: false,
  ai_questions: 5,
  evidence_uploads: 3,
  auditor_invite: false,
  team_invite: false,
  assessment: true,
  gap_analysis: true,
  sprs_score: true,
  remediation_tasks: true,
};

export function isTrialExpired(trialStartedAt) {
  if (!trialStartedAt) return false;
  const start = new Date(trialStartedAt);
  const now = new Date();
  const diffDays = (now - start) / (1000 * 60 * 60 * 24);
  return diffDays > 7;
}

export function getTrialDaysRemaining(trialStartedAt) {
  if (!trialStartedAt) return 7;
  const start = new Date(trialStartedAt);
  const now = new Date();
  const diffDays = (now - start) / (1000 * 60 * 60 * 24);
  return Math.max(0, Math.ceil(7 - diffDays));
}

export default function TrialGate({ feature, profile, onUpgrade, children }) {
  // Not a trial user — render children normally
  if (!profile?.is_trial) {
    return <>{children}</>;
  }

  const featureAllowed = TRIAL_LIMITS[feature];

  // Feature is allowed during trial — render children normally
  if (featureAllowed === true) {
    return <>{children}</>;
  }

  // Feature is blocked — show upgrade modal (no dismiss)
  const daysRemaining = getTrialDaysRemaining(profile?.trial_started_at);

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw', height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999,
      }}>
        <div style={{
          backgroundColor: 'var(--surface)',
          borderRadius: 12,
          padding: 32,
          maxWidth: 420,
          width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          border: '1px solid var(--border)',
          display: 'flex', flexDirection: 'column', gap: 16,
        }}>
          <p style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', margin: 0, lineHeight: 1.3 }}>
            Upgrade to unlock this feature
          </p>
          <p style={{ fontSize: 14, color: 'var(--text2)', margin: 0, lineHeight: 1.6 }}>
            Your 7-day free trial gives you access to the assessment and gap analysis. To export
            your SSP, download policy templates, and access all features, upgrade to a paid plan.
          </p>
          <p style={{ fontSize: 13, color: 'var(--amber)', fontWeight: 500, margin: 0 }}>
            {daysRemaining === 1
              ? '1 day remaining in your trial'
              : `${daysRemaining} days remaining in your trial`}
          </p>
          <button
            onClick={() => { if (onUpgrade) onUpgrade(); }}
            style={{
              backgroundColor: 'var(--accent)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '12px 16px',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
              width: '100%',
              textAlign: 'center',
              fontFamily: 'var(--font)',
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#245fa8')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'var(--accent)')}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </>
  );
}
